import axios from 'axios';
import ReactGA from 'react-ga';
import { window, document, exists } from 'browser-monads';
import Auth from './Common/Auth';

class Common {
    static DEV_ENDPOINT = "https://cb-api.stockenja.com/";
    // static DEV_ENDPOINT = "http://127.0.0.1:8000/"
    static EMPEROR_MODE = 'emperor_mode'

    static SPADE = "\u2660"
    static HEART = "\u2665"
    static CLOVER = "\u2663"
    static DIAMOND = "\u2666"

    static queriesInProgress = []

    static convertCardStringToSuits(cardString) {
        let newCardString = cardString.replace(/d/g, Common.DIAMOND)
        newCardString = newCardString.replace(/c/g, Common.CLOVER)
        newCardString = newCardString.replace(/h/g, Common.HEART)
        newCardString = newCardString.replace(/s/g, Common.SPADE)

        return newCardString
    }

    static isNumPlayerReasonable(state) {
        let numPlayers = state.numPlayer.replace(/\s/g,'')
        return numPlayers <= 12
    }

    static generateQueryString(state) {
        // console.log(state)
        let numPlayers = state.numPlayer.replace(/\s/g,'')

        if(numPlayers === "") {
            window.alert("Please make sure you have a valid numbers of players.")
            return null
        }

        if(!Common.isNumPlayerReasonable(state)) {
            return null
        }

        let myFirstCard = state.myFirstCard.replace(/\s/g,'')
        let mySecondCard = state.mySecondCard.replace(/\s/g,'')

        if(myFirstCard === "" || mySecondCard === "") {
            window.alert("Please make sure you have a valid hand.")
            return null
        }

        let queryString = "num_players=" + numPlayers
        queryString = queryString + "&player_hand=" + myFirstCard + "," + mySecondCard

        let sizeOfCommunityCard = 0

        state.communityCards.forEach((card) => {
            sizeOfCommunityCard = sizeOfCommunityCard + card.replace(/\s/g,'').length
        })

        if(sizeOfCommunityCard > 0) {
            queryString = queryString + "&community_cards="

            state.communityCards.forEach((card) => {
                let cleanedCard = card.replace(/\s/g,'')
                if(cleanedCard.length === 1 || cleanedCard.length > 3) {
                    window.alert("The card " + card + " is not a valid input")
                    return null
                }

                if(cleanedCard.length === 2 || cleanedCard.length === 3) {
                    queryString = queryString + cleanedCard + ","
                }
            })

            if(queryString[queryString.length -1] === ",") {
                queryString = queryString.slice(0, -1)
            }
        }

        return queryString
    }

    static getStateBasedUrlParams(state) {
        let queryString = Common.generateQueryString(state)

        if(queryString === null) {
            return ''
        }

        queryString = queryString.replace('num_players', 'n')
        queryString = queryString.replace('player_hand', 'h')

        if(queryString.includes('community_cards')) {
            queryString = queryString.replace('community_cards', 's')
        }

        return queryString
    }

    static getAnalysisFromServer = (obj) => {
        let auth = new Auth(null);
        let token = auth.getLocalToken()

        obj.setState({isCalculating: true})

        let queryString = Common.generateQueryString(obj.state);

        if(queryString == null) {
            obj.setState({isCalculating: false})
            return
        }

        if(Common.queriesInProgress.includes(queryString)) {
            return
        }

        Common.queriesInProgress.push(queryString)

        const httpClient = axios.create();
        httpClient.defaults.timeout = 2000;

        let headers = {}
        if(token !== null) {
            headers = {'Authorization': "Token " + token};
        }

        httpClient.get(Common.getProbEndpoint() + "holdem-prob/v2/?" + queryString, {headers: headers})
        .then((response) => {
            // console.log(response.data);

            let analysisColorClass = ""
            let advice = response.data.strategy.advice
            let minPaybackRatio = response.data.strategy.minPaybackRatio
            let optimalBet = response.data.strategy.optimalBet
            let opponentsWinRate = response.data.opponents_win_rate
            let handRankText = response.data.handRank

            if(advice === "Fold") {
                analysisColorClass = "bad-color"
                advice = "Check/Fold"
                minPaybackRatio = -1
                optimalBet = {}
            }

            let top5OpponentHand = [];

            if(response.data.top5winningPattern.length > 0) {
                top5OpponentHand = response.data.top5winningPattern;
            }

            obj.setState({
                myWinRate: (response.data.my_win_rate*100).toFixed(3),
                opponentsWinRate: (opponentsWinRate*100).toFixed(3),
                opponentsWinningHandStatus: response.data.winningPatternStatus,
                top5OpponentHand: top5OpponentHand, 
                action: advice,
                minPaybackRatio: minPaybackRatio,
                optimalBet: optimalBet,
                analysisColorClass: analysisColorClass,
                handRank: handRankText,
                needScrolling: true
            })

            ReactGA.event({
                category: 'Interact',
                action: 'Calculate Odds',
                label: queryString,
            });
        })
        .catch((error) => {
            try {
                if(error.response !== undefined) {
                    ReactGA.event({
                        category: 'Error',
                        action: 'Calculate Odds Error',
                        label: error.response.data.message,
                    });

                    window.alert("Server temporary unavailable... Message: " + error.response.data.message);
                } else {
                    ReactGA.event({
                        category: 'Error',
                        action: 'Calculate Odds Error',
                        label: 'Unknown',
                    });
                    window.alert("Server temporary unavailable...");
                }
            } catch(e) {
                window.alert("Server temporary unavailable...");
            }
            
        })
        .then(() => {
            Common.queriesInProgress = Common.queriesInProgress.filter((item) => {
                return item !== queryString
            })
            obj.setState({isCalculating: false})
        });
    }

    static isCardPresent(firstHand, secondHand, sharedCards, card) {
        if(firstHand.toLowerCase() === card.toLowerCase()) {
            return true
        }

        if(secondHand.toLowerCase() === card.toLowerCase()) {
            return true
        }

        for(let i=0; i<sharedCards.length; i++) {
            let sharedCard = sharedCards[i]

            if(sharedCard.toLowerCase() === card.toLowerCase() && sharedCard !== "") {
                return true
            }
        }

        return false
    }

    static shouldShowHandResults(state) {
        let firstHand = state.myFirstCard
        let secondHand = state.mySecondCard
        let sharedCards = state.communityCards

        let shouldDisplay = false

        if(firstHand !== undefined && secondHand !== undefined && 
            firstHand.length >= 2 && secondHand.length>=2) {
            if(sharedCards[0].length <= 3 &&
                sharedCards[1].length <= 3 &&
                sharedCards[2].length < 2 && 
                state.top5OpponentHand.length == 0) {
                
                shouldDisplay = true
            }
        }

        return shouldDisplay

    }

    static shouldShowFinalResults(firstHand, secondHand, sharedCards) {
        let shouldDisplay = false

        if(firstHand !== undefined && secondHand !== undefined && 
            firstHand.length >= 2 && secondHand.length>=2) {
            if(sharedCards[0].length >= 2 &&
                sharedCards[1].length >= 2 &&
                sharedCards[2].length >= 2) {
                    
                shouldDisplay = true
            }
        }

        return shouldDisplay
    }

    static isRedirectedCompute() {
        if(exists(window)) {
            let urlParams = new URLSearchParams(window.location.search);
            let numPlayer = urlParams.get('n');

            return (numPlayer !== undefined && numPlayer !== null && numPlayer !== '')
        } else {
            return false
        }
    }

    static shouldAutoAnalyze(firstHand, secondHand, sharedCards) {
        if(firstHand !== undefined && secondHand !== undefined && 
            firstHand.length >= 2 && secondHand.length>=2) {
            
            let isAllSharedCardEmpty = true

            for(let i=0; i<sharedCards.length; i++) {
                if(sharedCards[i].length >= 2) {
                    isAllSharedCardEmpty = false
                    break
                }
            }

            if(isAllSharedCardEmpty) {
                console.log("Should analyze because # shared cards is 0")
                return true
            } else {
                for(let j=sharedCards.length; j>=3; j--) {
                    let isNCardFilled = true

                    for(let k=0; k<j; k++) {
                        isNCardFilled = isNCardFilled & (sharedCards[k].length >= 2)
                    }

                    if(isNCardFilled) {
                        console.log("Should analyze because # shared cards is " + j)
                        return true
                    }
                }
            }
        }

        return false
    }

    static checkQueryParam = (field) => {
        let url = window.location.href;
        if(url.indexOf('?' + field) !== -1)
            return true;
        else if(url.indexOf('&' + field) !== -1)
            return true;
        return false
    }

    static removeQueryString() {
        if(!Common.checkQueryParam(Common.EMPEROR_MODE)) {
            window.history.pushState({}, document.title, "/")
        }
    }

    static getCurrentPageUrl = () => {
        let url = ""

        if(exists(window)) {
            let currentUrl = window.location.href;
            url = currentUrl.replace("http://localhost:8000", "https://app.edge.poker")
            url = currentUrl.replace("http://127.0.0.1:8000", "https://app.edge.poker")
        } 

        return url
    }

    static getEndpoint = () => {
        if(exists(window)) {
            let currentHostname = window.location.hostname;
            console.log(currentHostname)

            if (currentHostname === 'localhost' || currentHostname === '127.0.0.1') {
                console.log(Common.DEV_ENDPOINT)
                return Common.DEV_ENDPOINT
            } else {
                return 'https://cb-api.stockenja.com/'
            }
        } else {
            return 'https://cb-api.stockenja.com/'
        }
    }

    static getProbEndpoint = () => {
        return Common.getEndpoint() + 'texas-holdem/'
    }
}

export default Common;